import { OMPGtagF } from '../../../../OMP/Gtag/F/Function/module/OMPGtagF.js';

export const handleFirstImageButtonClick = (button_name) => {
  if (window.firstImgUplodButtonClickRecorded) return;

  OMPGtagF.sendEventFirstClickImageButton({ button_name });
  window.firstImgUplodButtonClickRecorded = true;
};
